/* unplugin-vue-components disabled */import { render } from "./CDateHeaderWithBtn.vue?vue&type=template&id=1a9bddb0&scoped=true&ts=true"
import script from "./CDateHeaderWithBtn.vue?vue&type=script&lang=ts"
export * from "./CDateHeaderWithBtn.vue?vue&type=script&lang=ts"

import "./CDateHeaderWithBtn.vue?vue&type=style&index=0&id=1a9bddb0&lang=less&scoped=true"
import "./CDateHeaderWithBtn.vue?vue&type=style&index=1&id=1a9bddb0&lang=css"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9bddb0"]])

export default __exports__